export const DBA_DBN_BIZ_MAPPINGS_TYPES_RESET_STATE = 'DBA_DBN_BIZ_MAPPINGS_TYPES_RESET_STATE';
export const DBA_DBN_BIZ_MAPPINGS_TYPES_CURRENT_ITEM = 'DBA_DBN_BIZ_MAPPINGS_TYPES_CURRENT_ITEM';

export const DBA_DBN_BIZ_MAPPINGS_TYPES_REQUEST_LOADING = 'DBA_DBN_BIZ_MAPPINGS_TYPES_REQUEST_LOADING';
export const DBA_DBN_BIZ_MAPPINGS_TYPES_REQUEST_SUCCESS = 'DBA_DBN_BIZ_MAPPINGS_TYPES_REQUEST_SUCCESS';
export const DBA_DBN_BIZ_MAPPINGS_TYPES_REQUEST_FAILED = 'DBA_DBN_BIZ_MAPPINGS_TYPES_REQUEST_FAILED';

export const DBA_DBN_BIZ_MAPPINGS_TYPES_CURRENT_ACTION = 'DBA_DBN_BIZ_MAPPINGS_TYPES_CURRENT_ACTION';
export const DBA_DBN_BIZ_MAPPINGS_TYPES_RESET_ACTION = 'DBA_DBN_BIZ_MAPPINGS_TYPES_RESET_ACTION';